<template>
  <v-tooltip bottom content-class="tooltip-avatar-content" class="content">
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        class="content"
        v-bind="attrs"
        v-on="on"
        color="grey"
        :min-width="width"
        :min-height="height"
        :width="width"
        :height="height"
        :max-height="maxHeight"
        :max-width="maxWidth"
        >{{ initials }}</v-avatar
      >
    </template>
    <span>{{ fullName }}</span>
  </v-tooltip>
</template>

<script>
// TODO: [CW-129] Add image handling to user avatars
import { getInitials } from '@/common'

export default {
  name: 'UserAvatarComponent',
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    width: {
      type: [Number, String],
      required: false,
      default: 32,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 32,
    },
    maxWidth: {
      type: [Number, String],
      required: false,
    },
    maxHeight: {
      type: [Number, String],
      required: false,
    },
  },
  data: () => ({
    getInitials,
  }),
  computed: {
    initials() {
      return getInitials(
        [this.userInfo?.firstName ?? '', this.userInfo?.lastName ?? '']
          .join(' ')
          .trim()
      )
    },
    fullName() {
      return [this.userInfo?.firstName ?? '', this.userInfo?.lastName ?? '']
        .join(' ')
        .trim()
    },
  },
}
</script>

<style lang="sass" scoped>
.tooltip-avatar-content
  @include body_light
  padding: 2px 5px
  background-color: rgba(0, 0, 0, 0.8)
</style>
